<template>
    <div>
        <link href="https://img2.233.com/wx/union/pc/fine/category/css/jzs2.css" rel="stylesheet" type="text/css">
        <div class="wx-header-cont" id="wx-header-cont"> 
        <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
        <div class="wx-header-container">
            <div class="fl-box">
          <h1 class="logo"> <a href="/"><img  :src="logo" > </a> </h1>
            <div class="line"></div>
            <div class="wx-subject">
                <h2>二级建造师</h2>
                <i class="dropdown-arrow"></i>
                <div class="subject-list">
                        <a href="./#/jianli">监理工程师</a>
                        <a href="./#/aq">安全工程师</a>
                        <a href="./#/cfe">一级消防工程师</a>
                        <a href="./#/zaojia">造价工程师</a>
                        <a href="./#/jzs1">一级建造师</a>
                        <a href="./#/jzs2">二级建造师</a>
                        <a href="./#/zjy">二级造价工程师</a>
                        <a href="./#/zjxfy">消防设施操作员</a>
                </div>
            </div>
            <div class="head-area  text-gry6 font14 fl m-t-10"  style="display: none;"> 当前地区
                <p class="m-l-15  bg-white fr "><em class="now-area p-0-20">全国版</em><a href="" class="more-area p-0-10">更多地区 </a></p>
                <div class="area_list">
                <ul>
                    <li><a href="/tegang/guojia/#tgtc">全国</a></li>
                    <li><a href="/tegang/shanxi1/#tgtc">陕西</a></li>
                    <li><a href="/tegang/hebei/#tgtc">河北</a></li>
                    <li><a href="/tegang/henan/">河南</a></li>
                    <li><a href="/tegang/sichuan/#tgtc">四川</a></li>
                    <li><a href="/tegang/jiangxi/#tgtc">江西</a></li>
                    <li><a href="/tegang/yunnan/#tgtc">云南</a></li>
                    <li><a href="/tegang/heilongjiang/#tgtc">黑龙江</a></li>
                    <li><a href="/tegang/chongqing/#tgtc">重庆</a></li>
                    <li><a href="/tegang/hubei/#tgtc">湖北</a></li>
                </ul>
                </div>
            </div>
            </div>
            <div class="fr-box"> 
                <!--未登录 -->
                <div class="personal-no" v-if="!isLogin">
                    <p><a target="_blank" :href="'/uc/login?redirecturl='+href" class="red">登录</a>|<a target="_blank" :href="'/uc/register?redirecturl='+href">注册</a></p>
                </div>
                <div class="personal" v-else>
                            <a href="javascript:;" class="pic"><img :src="logoSrc" ><i class="dropdown-arrow"></i></a>
                            <div class="pop-personal">
                                <a href="javascript:" @click="loginout()"><i class="icon"></i><span class="txt">退出</span></a>
                            </div>
                </div>
                <div class="classify"> 
                    <a class="classify-list" href="/shopping/cart" target="_blank" title="购课车">
                    <p class="icon shopping"></p>
                    </a> </div>
                <div v-if="kefu.length>0" class="wx-telephone">
                    <p class="txt1">客服热线</p>
                    <p class="txt2">{{kefu}}</p>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        </div>
        <!--banner-->
        <div class="bg-black"> 
        <!--01banner-->
                <Banner imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/banner01.jpg"></Banner>
        <!--01banner 结束--> 
        <!---02试听区域--->
        <div class="video clearfix">
            <div class="video-layout">
            <div class="subject-tabBox clearfix" >
                <ul class="sub-tabL clearfix">
                <li class="line" @click="changeCourseIndex(i)" v-for="(v,i) in courses.slice(0,4)" :key="i">
                    <a href="javascript: void(0)"  :class="i==courseIndex?'hover':''">{{v.name}}</a>
                </li>
                </ul>
                <div class="Rselect-box" @mouseover="changeIsHoverCourse(true)" @mouseout="changeIsHoverCourse(false)" >
                <p class="subject-select currt clearfix"><span class="txt">选择其它科目</span><i class="ico"></i></p>
                <div class="sub-sel-list" v-show="isHoverCourse">
                    <ul>
                    <li v-for="(v,i) in courses.slice(4)" :key="i">
                        <a  @click="changeCourseIndex(i+4)" style="text-overflow:ellipsis; overflow:hidden; white-space:nowrap;" href="javascript: void(0)">{{v.name}}</a>
                    </li>
                    </ul>
                </div>
                </div>
            </div>
            <myvideo   :isLogin="isLogin"  :allLoginPlayFlag="allLoginPlayFlag"  :unionId="unionId" :classEname="'jzs2'" :logo="logo" :myClassId="courses[courseIndex].myClassId"></myvideo>
            </div>
            <div class="video-bottom"></div>
        </div>
        <!---02试听区域END---> 
        </div>
        <!--03原高级平台班级对比-->
        <banjiduibi :calssName="'二级建造师'" :classEName="'jzs2'"></banjiduibi>
        <!--03原高级平台班级对比 end--> 
            
        <!--04全部班级表格-->
        <quanbubanji :classEname="'jzs2'"></quanbubanji>
        <!--04全部班级表格 end--> 
        <div class="modular-mian modular-mian02" id="cxtp">
        <!-- 标题 -->
            <div class="headbox clearfix">
            <h3 class="head-title head-title02">
                <i class="point_left"></i><a name="3d"></a>创新突破<i class="point_right"></i><span class="banner"></span>
            </h3>
            <i class="title_bgnumb"></i>
            <span class="head-content head-content02">3项创新突破，针对性攻破备考难点</span>
            </div>
            <!-- 标题end -->
            <div class="wx-mian wx-mian-video3D clearfix">
                <div class="video3D_content clearfix">
                    <div class="video_3D_txt_box">
                        <dl class="left_content_txt">
                            <dt class="txt_title"><b>《3D动画教学》</b></dt>
                            <dd class="txt_title_span"><i></i><span>教材精讲班率先采用3D动画教学</span></dd>
                            <dd class="txt_title_span"><i></i><span>真实还原施工现场、施工工艺</span></dd>
                            <dd class="txt_title_span"><i></i><span>即使是零基础小白也能高分拿下实操</span></dd>
                            
                        </dl>
                    </div>
                    <div class="right_3Dvideo_box">
                        <div class="right_content_3Dvideo"></div> 
                    </div>
                </div>
                <ul class="innovation-ul-txt clearfix">
                    <li class="innovation-li-txt" style="margin-right: 20px;">
                        <dl class="innovation-txt">
                            <dt class="txt_title"><b>《思维导图讲解》</b></dt>
                            <dd class="txt_title_span"><em></em><span>每科教材约400页，考点繁杂难懂</span></dd>
                            <dd class="txt_title_span"><em></em><span>教材精讲班每章思维导图提纲挈领讲解</span></dd>
                            <dd class="txt_title_span"><em></em><span>形成整体知识脉络</span></dd>
                        </dl>
                    </li>
                    <li class="innovation-li-txt">
                        <dl class="innovation-txt">
                            <dt class="txt_title"><b>《案例专项攻克》</b></dt>
                            <dd class="txt_title_span"><em></em><span>案例考试难度大，全国通过率不到10%</span></dd>
                            <dd class="txt_title_span"><em></em><span>案例专项班针对案例难题专项训练</span></dd>
                            <dd class="txt_title_span"><em></em><span>汇总解题思路和方法</span></dd>
                            <dd class="txt_title_span"><em></em><span>案例答题“下笔如有神”</span></dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </div>

        <div class="modular-mian modular-mian-ytcg" id="sztd">
            <!--标题-->
            <div class="headbox clearfix">
                <h3 class="head-title">
                    <i class="point_left"></i>师资团队<i class="point_right"></i><span class="banner"></span>
                </h3>
                <i class="title_bgnumb"></i>
                <span class="head-content">双名师教学，1个科目2个老师主讲，自由选择喜爱的老师</span>
            </div>
            <!--标题 end-->

            <div class="teacher-list-js clearfix" data-type="{cs1:'on',cs2:'t1-curr',tlist:'.tea-list img',clist:'.tea-txt'}" node-type="menu-tab">
                <div class="tea-list clearfix">
                    <img @mouseover="changeTeacherIndex(0)" :class="teacherIndex==0?'t1 on':'t1 t1-curr'" src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/01-zcx.png">
                    <img @mouseover="changeTeacherIndex(1)" :class="teacherIndex==1?'t2 on':'t2 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/02-wzm.png">
                    <img @mouseover="changeTeacherIndex(2)" :class="teacherIndex==2?'t3 on':'t3 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/03-zjm.png">
                    <img @mouseover="changeTeacherIndex(3)" :class="teacherIndex==3?'t4 on':'t4 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/04-lpp.png">
                    <img @mouseover="changeTeacherIndex(4)" :class="teacherIndex==4?'t5 on':'t5 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/05-hy.png">
                    <img @mouseover="changeTeacherIndex(5)" :class="teacherIndex==5?'t11 on':'t11 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/11-hd.png">
                    <img @mouseover="changeTeacherIndex(6)" :class="teacherIndex==6?'t6 on':'t6 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/06-yzl.png">
                    <img @mouseover="changeTeacherIndex(7)" :class="teacherIndex==7?'t7 on':'t7 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/07-ljh.png">
                    <img @mouseover="changeTeacherIndex(8)" :class="teacherIndex==8?'t8 on':'t8 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/08-gw.png">
                    <img @mouseover="changeTeacherIndex(9)" :class="teacherIndex==9?'t9 on':'t9 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/09-wxy.png">
                    <img @mouseover="changeTeacherIndex(10)" :class="teacherIndex==10?'t10 on':'t10 t1-curr'"  src="https://img2.233.com/wx/union/pc/fine/category/img/jzs2/10-lyf.png">
                </div>
                <div class="tea-txt" v-for="(v,i) in teachers" :key="i" v-show="i==teacherIndex">
                    <ul class="tea-details clearfix">
                        <li class="tea-name">
                            <span>{{v.name}}</span>
                            <p>{{v.years}}</p>
                        </li>
                        <li class="">
                            <span class="tea-black">主&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;讲:<i class="tea-red">{{v.courseName}}</i></span>
                        </li>
                        <li class="">
                            <span class="tea-black">简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;介：<i class="tea-ash">{{v.jianjie}}</i></span>
                        </li>
                        <li class="">
                            <span class="tea-black">特&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;色：<i class="tea-ash">{{v.tese}}</i></span> 
                        </li>
                        <li class="">
                            <span class="tea-black">学员评价：<i class="tea-ash">{{v.pinjia}}</i></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
       <!--智能题库模块-->
        <div class="wx-course zhinneg_md">
            <div class="wx-mian clearfix">
                <!--标题-->
                <div class="headbox clearfix">
                    <h3 class="head-title head-title02">
                        <i class="point_left">
                        </i>
                        智能题库
                        <i class="point_right">
                        </i>
                        <span class="banner">
                        </span>
                    </h3>
                    <i class="title_bgnumb">
                    </i>
                    <span class="head-content head-content02">
                        配套赠送题库VIP会员，专业智能，高效提分
                    </span>
                </div>
                <!--标题 end-->
                <div class="zhineng_md_all clearfix">
                    <div class="zntk_md_left">
                        <h4>
                            品质过硬
                        </h4>
                        <ul class="znmd_left_ul clearfix">
                            <li>
                                <div class="znmk_md1 clearfix">
                                    <i class="znmd_icon znmd_img_1">
                                    </i>
                                    <div class="znmd_li_title">
                                        <h5>
                                            专业解析
                                        </h5>
                                        <p>
                                            每道题
                                            <font class="ft_bold">
                                                配有专业答案解析
                                            </font>
                                            <br>
                                            解密题目背后的考点逻辑
                                        </p>
                                    </div>
                                </div>
                                <a>
                                    注：付费学员专享100%章节题量
                                </a>
                            </li>
                            <li>
                                <div class="znmk_md1 clearfix">
                                    <i class="znmd_icon znmd_img_2">
                                    </i>
                                    <div class="znmd_li_title">
                                        <h5>
                                            助教答疑
                                        </h5>
                                        <p>
                                            每道题
                                            <font class="ft_bold">
                                                专业助教答疑服务
                                            </font>
                                            <br>
                                            做题不留任何疑问
                                        </p>
                                    </div>
                                </div>
                                <a class="znmd_a_bg2">
                                    注：付费学员专享
                                </a>
                            </li>
                            <li class="bottom_pt18">
                                <div class="znmk_md1 clearfix">
                                    <i class="znmd_icon znmd_img_3">
                                    </i>
                                    <div class="znmd_li_title">
                                        <h5>
                                            模考大赛
                                        </h5>
                                        <p>
                                            万名考生同场闯关做题
                                            <br>
                                            <font class="ft_bold">
                                                并配套名师直播讲题
                                            </font>
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li class="bottom_pt18">
                                <div class="znmk_md1 clearfix">
                                    <i class="znmd_icon znmd_img_4">
                                    </i>
                                    <div class="znmd_li_title">
                                        <h5>
                                            视频解析
                                        </h5>
                                        <p>
                                            重难点考题配套视频解析
                                            <br>
                                            <font class="ft_bold">
                                                授课名师分析答题“套路”
                                            </font>
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="znmk_md1 clearfix">
                                    <i class="znmd_icon znmd_img_5">
                                    </i>
                                    <div class="znmd_li_title">
                                        <h5>
                                            2套考前点题
                                        </h5>
                                        <p>
                                            考前10天上线2套点题
                                            <br>
                                            <font class="ft_bold">
                                                专业师资高效预测考点
                                            </font>
                                        </p>
                                    </div>
                                </div>
                                <a class="znmd_a_bg2">
                                    注：付费学员专享
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="zntk_md_right">
                        <h4>
                            智能系统
                        </h4>
                        <ul class="znmd_right_ul clearfix">
                            <li class="znmd_rli    znmd_rli_bg1">
                                <div class="znmdli_right_title">
                                    <h5>
                                        云计算
                                    </h5>
                                    <p>
                                        数百万用户高频错题
                                        <br>
                                        <font class="ft_bold2">
                                            帮助避开常见失分点
                                        </font>
                                    </p>
                                </div>
                            </li>
                            <li class="znmd_rli  color_blue   znmd_rli_bg2">
                                <div class="znmdli_right_title">
                                    <h5>
                                        错题归纳
                                    </h5>
                                    <p>
                                        错题按章节和题型归类
                                        <br>
                                        <font class="ft_bold2">
                                            智能汇总个人薄弱考点
                                        </font>
                                    </p>
                                </div>
                            </li>
                            <li class="znmd_rli  color_blue   znmd_rli_bg3">
                                <div class="znmdli_right_title">
                                    <h5>
                                        大数据提分
                                    </h5>
                                    <p>
                                        结合考情，分析章节分值
                                        <br>
                                        <font class="ft_bold2">
                                            大数据预判考点，精准提分
                                        </font>
                                    </p>
                                </div>
                            </li>
                            <li class="znmd_rli    znmd_rli_bg4">
                                <div class="znmdli_right_title">
                                    <h5>
                                        智能评分
                                    </h5>
                                    <p>
                                        <font class="ft_bold2">
                                            系统根据做题数据智能评分
                                        </font>
                                        <br>
                                        科学评测做题水准
                                    </p>
                                </div>
                            </li>
                            <li class="znmd_rli    znmd_rli_bg5">
                                <div class="znmdli_right_title">
                                    <h5>
                                        离线做题
                                    </h5>
                                    <p>
                                        网校APP支持套题下载
                                        <br>
                                        <font class="ft_bold2">
                                            随时随地免流量刷题
                                        </font>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--智能题库模块 end-->
        <!-- 授课体系 -->
        <div class="wx-course gray2-course" id="sktx">
            <div class="wx-mian wx-raiders">
                <!--标题-->
                <div class="headbox clearfix">
                    <h3 class="head-title">
                        <i class="point_left">
                        </i>
                        授课体系
                        <i class="point_right">
                        </i>
                        <span class="banner">
                        </span>
                    </h3>
                    <i class="title_bgnumb">
                    </i>
                    <span class="head-content">
                        分阶段科学教学，稳步提升有保障
                    </span>
                </div>
                <!--标题 end-->
                <div class="review clearfix">
                    <ul class="raiders-step fl">
                        <li @mouseover="changeTixiIndex(0)" :class="tixiIndex==0?'raiders-step-selected':''">
                            <p>
                                基础阶段
                                <br>
                                <i>
                                    全面锁定教材考点
                                </i>
                            </p>
                        </li>
                        <li @mouseover="changeTixiIndex(1)" :class="tixiIndex==1?'raiders-step-selected':''">
                            <p>
                                强化阶段
                                <br>
                                <i>
                                    强化巩固，化繁为简
                                </i>
                            </p>
                        </li>
                        <li @mouseover="changeTixiIndex(2)" :class="tixiIndex==2?'raiders-step-selected':''">
                            <p>
                                冲刺阶段
                                <br>
                                <i>
                                    查漏补缺临考提分
                                </i>
                            </p>
                        </li>
                    </ul>
                    <div class="raiders-bj fl" v-show="tixiIndex==0">
                        <div class="raiders-list fl" style="border-bottom: 1px solid #f1f1f1;padding-bottom: 20px;">
                            <dl class="raiders-list-dl fl">
                                <dt>
                                    <b>
                                    </b>
                                    <em class="digital-one">
                                        01
                                    </em>
                                    <span>
                                        零基础入门班
                                    </span>
                                </dt>
                                <dd>
                                    为零基础考生定制，在新教材出来前，帮助考生梳理学习思路及备考指导。
                                </dd>
                            </dl>
                            <ul class="raiders-list-ul fl">
                                <li>
                                    <b>
                                        学习效果
                                        <i>
                                        </i>
                                    </b>
                                    <span class="raiders-red">
                                        帮助零基础考生快速进入学习状态，积累备考经验
                                    </span>
                                </li>
                                <li>
                                    <b>
                                        学习时间
                                        <i>
                                        </i>
                                    </b>
                                    <span>
                                        1-3小时/科
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="raiders-list raiders-list-top fl" style="border-bottom: 1px solid #f1f1f1;padding-bottom: 20px;">
                            <dl class="raiders-list-dl fl">
                                <dt>
                                    <b>
                                    </b>
                                    <em class="digital-two">
                                        02
                                    </em>
                                    <span>
                                        教材精讲班
                                    </span>
                                </dt>
                                <dd>
                                    根据教材或考试大纲，全面讲解各章节知识点，帮助考生牢固夯实基础。
                                </dd>
                            </dl>
                            <ul class="raiders-list-ul fl">
                                <li>
                                    <b>
                                        学习作用
                                        <i>
                                        </i>
                                    </b>
                                    <span class="raiders-red">
                                        帮助考生全面夯实基础，掌握90%教材考点
                                    </span>
                                </li>
                                <li>
                                    <b>
                                        学习方法
                                        <i>
                                        </i>
                                    </b>
                                    <span>
                                        29-34小时/科
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="raiders-list fl">
                            <dl class="raiders-list-dl fl">
                                <dt>
                                    <b>
                                    </b>
                                    <em class="digital-three">
                                        03
                                    </em>
                                    <span>
                                        习题班
                                    </span>
                                </dt>
                                <dd>
                                    针对性讲解具有代表性的典型习题，分析出题方向，总结各题型答题技巧。
                                </dd>
                            </dl>
                            <ul class="raiders-list-ul fl">
                                <li>
                                    <b>
                                        学习作用
                                        <i>
                                        </i>
                                    </b>
                                    <span class="raiders-red">
                                        帮助考生强化巩固知识点，提升做题技巧及效率
                                    </span>
                                </li>
                                <li>
                                    <b>
                                        学习时长
                                        <i>
                                        </i>
                                    </b>
                                    <span>
                                        5-6小时/科
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="raiders-score-r">
                            <p class="score-top">
                                基础阶段帮你
                                <br>
                                攻克
                                <br>
                                <b>
                                    90%
                                </b>
                                <span>
                                    知识点
                                </span>
                            </p>
                            <p class="score-bottom">
                                <i class="score-jian">
                                </i>
                                <i class="score-dian">
                                </i>
                                <span>
                                    拿下
                                    <br>
                                    <b>
                                        50
                                    </b>
                                    分
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="raiders-bj fl" v-show="tixiIndex==1">
                        <div class="raiders-list raiders-list-top fl" style="border-bottom: 1px solid #f1f1f1;padding-bottom: 20px;">
                            <dl class="raiders-list-dl fl">
                                <dt>
                                    <b>
                                    </b>
                                    <em class="digital-four">
                                        04
                                    </em>
                                    <span>
                                        高频考点班
                                    </span>
                                </dt>
                                <dd>
                                    串讲历年考试中反复出题的高频考点，针对性突破重难点，稳抓核心分值。
                                </dd>
                            </dl>
                            <ul class="raiders-list-ul fl">
                                <li>
                                    <b>
                                        学习效果
                                        <i>
                                        </i>
                                    </b>
                                    <span class="raiders-red">
                                        帮助考生巩固重难点，提升学习效果，节约备考时间
                                    </span>
                                </li>
                                <li>
                                    <b>
                                        学习时间
                                        <i>
                                        </i>
                                    </b>
                                    <span>
                                        4-6小时/科
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="raiders-list raiders-list-top fl" style="border-bottom: 1px solid #f1f1f1;padding-bottom: 20px;">
                            <dl class="raiders-list-dl fl">
                                <dt>
                                    <b>
                                    </b>
                                    <em class="digital-five">
                                        05
                                    </em>
                                    <span>
                                        案例专项班
                                    </span>
                                </dt>
                                <dd>
                                    讲解具有代表性的典型案例题，强化记忆案例题高频考点，总结答题套路。
                                </dd>
                            </dl>
                            <ul class="raiders-list-ul fl">
                                <li>
                                    <b>
                                        学习效果
                                        <i>
                                        </i>
                                    </b>
                                    <span class="raiders-red">
                                        帮助考生攻克案例题死穴，提升案例题正确率
                                    </span>
                                </li>
                                <li>
                                    <b>
                                        学习时间
                                        <i>
                                        </i>
                                    </b>
                                    <span>
                                        10小时/科
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="raiders-list fl">
                            <dl class="raiders-list-dl fl">
                                <dt>
                                    <b>
                                    </b>
                                    <em class="digital-six">
                                        06
                                    </em>
                                    <span>
                                        真题解析班
                                    </span>
                                </dt>
                                <dd>
                                    对当年的考试真题进行详细讲解，并结合课程预测下次考试趋势及方向。
                                </dd>
                            </dl>
                            <ul class="raiders-list-ul fl">
                                <li>
                                    <b>
                                        学习效果
                                        <i>
                                        </i>
                                    </b>
                                    <span class="raiders-red">
                                        帮助考生了解真题，全面掌握考试难度以及出题规律
                                    </span>
                                </li>
                                <li>
                                    <b>
                                        学习时间
                                        <i>
                                        </i>
                                    </b>
                                    <span>
                                        4-15小时/科
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="raiders-score-r">
                            <p class="score-top">
                                强化阶段帮你
                                <br>
                                巩固
                                <br>
                                <b>
                                    80%
                                </b>
                                <span>
                                    考点
                                </span>
                            </p>
                            <p class="score-bottom score-bottom2">
                                <i class="score-jian">
                                </i>
                                <i class="score-dian">
                                </i>
                                <span>
                                    再提
                                    <br>
                                    <b>
                                        30
                                    </b>
                                    分
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="raiders-bj fl" v-show="tixiIndex==2">
                        <div class="raiders-list raiders-list-top fl" style="border-bottom: 1px solid #f1f1f1;padding-bottom: 20px;">
                            <dl class="raiders-list-dl fl">
                                <dt>
                                    <b>
                                    </b>
                                    <em class="digital-seven">
                                        07
                                    </em>
                                    <span>
                                        直播班
                                    </span>
                                </dt>
                                <dd>
                                    通过直播的形式，在不同备考阶段进行直播密训，在直播中解答学员疑问。
                                </dd>
                            </dl>
                            <ul class="raiders-list-ul fl">
                                <li>
                                    <b>
                                        学习效果
                                        <i>
                                        </i>
                                    </b>
                                    <span class="raiders-red">
                                        帮助考生打通备考关键环节，面对面交流解决备考难题
                                    </span>
                                </li>
                                <li>
                                    <b>
                                        学习时间
                                        <i>
                                        </i>
                                    </b>
                                    <span>
                                        1.5小时/科
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="raiders-list raiders-list-top fl">
                            <dl class="raiders-list-dl fl">
                                <dt>
                                    <b>
                                    </b>
                                    <em class="digital-eight">
                                        08
                                    </em>
                                    <span>
                                        考题突击班
                                    </span>
                                </dt>
                                <dd>
                                    讲解2套高含金量考题突击卷，并配套电子版在线试题，预测考试方向及趋势。
                                </dd>
                            </dl>
                            <ul class="raiders-list-ul fl">
                                <li>
                                    <b>
                                        学习效果
                                        <i>
                                        </i>
                                    </b>
                                    <span class="raiders-red">
                                        帮助考生抢先做真正的“考题”，实现短期快速冲分
                                    </span>
                                </li>
                                <li>
                                    <b>
                                        学习时间
                                        <i>
                                        </i>
                                    </b>
                                    <span>
                                        4小时/科
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="raiders-score-r">
                            <p class="score-top">
                                冲刺阶段帮你
                                <br>
                                拿下
                                <br>
                                <b>
                                    80%
                                </b>
                                <span>
                                    考分
                                </span>
                            </p>
                            <p class="score-bottom score-bottom3">
                                <i class="score-jian">
                                </i>
                                <i class="score-dian">
                                </i>
                                <span>
                                    稳提
                                    <br>
                                    <b>
                                        20
                                    </b>
                                    分
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 授课体系 end-->
        <!--考情分析-->
        <div class="modular-mian modular-mian01" id="kqfx">
            <!-- 标题 -->
            <div class="headbox clearfix">
                <h3 class="head-title head-title02">
                    <i class="point_left">
                    </i>
                    考情分析
                    <i class="point_right">
                    </i>
                    <span class="banner">
                    </span>
                </h3>
                <i class="title_bgnumb">
                </i>
                <span class="head-content head-content02">
                    3大政策改革，抢先备考取证
                </span>
            </div>
            <!-- 标题end -->
            <div class="zsjz-list-box">
                <div class="left_box_title clearfix">
                    <p class="left_text_small">
                        <i class="pointer_left01">
                        </i>
                        二建考试
                        <i class="pointer_right02">
                        </i>
                    </p>
                    <h3 class="left_h3">
                        三大改革
                    </h3>
                    <p class="reform_text">
                        2020二建考试难度增大，自学通过率降低，提前跟着网校备考更有胜算。
                    </p>
                </div>
                <ul class="clearfix">
                    <li class="zsjz-bj">
                        <h3 class="zsjz-ico">
                            2020实行机考？
                        </h3>
                        <p class="zsjz-title">
                            2019下半年福建二建实行机考，相比笔试
                            <font style="color:#f6283d">
                                机考每个科目考试时间缩短半小时，
                            </font>
                            2020年即将全面实行机考？
                        </p>
                        <p class="zsjz-txt">
                            <i class="read_bg">
                                解读
                            </i>
                            这就意味着除了要熟悉电脑操作，
                            <font style="color:#f6283d">
                                考试难度也一定程度上增大了！
                            </font>
                        </p>
                        <div class="main_quan main_quan01">
                            <span class="xz_quan">
                            </span>
                            <p class="main_quan_wz">
                                实行机考
                            </p>
                        </div>
                    </li>
                    <li class="zsjz-bj">
                        <h3 class="zsjz-ico">
                            临时证书取消
                        </h3>
                        <p class="zsjz-title">
                            <strong style="font-weight: bold;">
                                住房和城乡建设部办公厅通知：
                            </strong>
                            <br>
                            持有一、二级建造师临时执业证书且正在担任施工单位项目负责人的，在2019年12月31日前，暂可继续担任该项目的项目负责人；其聘用企业应尽快按照有关要求
                            <font style="color:#f6283d">
                                更换项目负责人。
                            </font>
                        </p>
                        <p class="zsjz-txt">
                            <i class="read_bg">
                                解读
                            </i>
                            一、二建临时证书取消，持证上岗成为担任项目经理的必要条件！
                        </p>
                        <div class="main_quan ">
                            <span class="xz_quan">
                            </span>
                            <p class="main_quan_wz">
                                临时证书
                            </p>
                        </div>
                    </li>
                    <li class="zsjz-bj">
                        <h3 class="zsjz-ico">
                            按60%划定分数线
                        </h3>
                        <p class="zsjz-title">
                            2019年二建多省报名公告均已提及按照卷面总分的60%划定分数线，也就是说自2019年起，二级建造师执业资格考试各科目合格分数线原则上均按照卷面总分的60%划定。
                        </p>
                        <p class="zsjz-txt">
                            <i class="read_bg">
                                解读
                            </i>
                            如果按60%划定分数线，意味着提高考试合格标准，二建考试难度增大，通过率降低！
                        </p>
                        <div class="main_quan main_quan03">
                            <span class="xz_quan">
                            </span>
                            <p class="main_quan_wz">
                                60%划定
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!--考情分析 end-->
        <!--06套用官网内容 end------------->
        <!--05服务特色标题-->
        <div class="main-title f-tac m-b-30 p-t-50">
            <p class="font-bg">
                CHARACTERISTIC
            </p>
            <h2 class="font44 fb">
                选择我们的
                <em class="text-red fb">
                    四大理由
                </em>
            </h2>
            <p class="font17 text-gry-6 lh2">
                服务保障，学习无忧，通关指日可待
            </p>
        </div>
        <div class="fuwu-bg ">
            <div class="fuwu-content">
                <div class="fuwu-box">
                    <ul class="clearfix m-b-20">
                        <li>
                            <h4 class="f-tac fb font24 m-b-20">
                                <span class="m-r-5 bg-sblue">
                                    1
                                </span>
                                课程品质高
                            </h4>
                            <p class="font15 lh2 p-15">
                                课程专业的教研团队精心打造，
                                <em class="text-red fb">
                                    每个课程均经过20+次以上迭代
                                </em>
                                。
                            </p>
                        </li>
                        <li>
                            <h4 class="f-tac fb font24 m-b-20">
                                <span class="m-r-5 bg-sblue">
                                    2
                                </span>
                                老师实力强
                            </h4>
                            <p class="font15 lh2 p-15">
                                网校执行严格的
                                <em class="text-red fb">
                                    师资淘汰制，由购课学员评分
                                </em>
                                ，努力建设零差评老师团队。
                            </p>
                        </li>
                        <li>
                            <h4 class="f-tac fb font24 m-b-20">
                                <span class="m-r-5 bg-sblue">
                                    3
                                </span>
                                学习服务优
                            </h4>
                            <p class="font15 lh2 p-15">
                                您在学习课程中遇到任何问题，可在线提问，专业老师
                                <em class="text-red fb">
                                    24小时内为您答疑解惑
                                </em>
                                。
                            </p>
                        </li>
                        <li>
                            <h4 class="f-tac fb font24 m-b-20">
                                <span class="m-r-5 bg-sblue">
                                    4
                                </span>
                                售后服务好
                            </h4>
                            <p class="font15 lh2 p-15">
                                部分套餐课程享
                                <em class="text-red fb">
                                    超长有效期
                                </em>
                                ，课程有效期内考试
                                <em class="text-red fb">
                                    不过免费重学
                                </em>
                                保障。
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--05服务特色 end-->
    </div>
</template>
<script>
import myvideo from '@/components/myvideo'
import banjiduibi from '@/components/banjiduibi'
import quanbubanji from '@/components/quanbubanji'
import { getMemberPicpath } from '@/request/request.js'
export default {
  name: 'App',
  components: {
    banjiduibi,
    quanbubanji,
    myvideo
  },  
  data() {
    return {
      laoshiindex:0,
      isLogin:false,
      logoSrc:"",
      allLoginPlayFlag:false,
      unionId:"",
      kefu:"",
      logo:"",
      href:"",
      courses:[
        // {name:'建设工程法规及相关知识',myClassId:29000},
        // {name:'建设工程施工管理',myClassId:29001},
        // {name:'建筑工程管理与实务',myClassId:29003},
        // {name:'公路工程管理与实务',myClassId:29006},
        // {name:'市政公用工程管理与实务',myClassId:29002},
        // {name:'机电工程管理与实务',myClassId:29004},
        // {name:'水利水电工程管理与实务',myClassId:29005},
        // {name:'矿业工程管理与实务',myClassId:29007},
        {name:'建设工程法规及相关知识',myClassId:33131},
        {name:'建设工程施工管理',myClassId:33132},
        {name:'建筑工程管理与实务',myClassId:33134},
        {name:'公路工程管理与实务',myClassId:33137},
        {name:'市政公用工程管理与实务',myClassId:33133},
        {name:'机电工程管理与实务',myClassId:33135},
        {name:'水利水电工程管理与实务',myClassId:33136},
        {name:'矿业工程管理与实务',myClassId:33138},
      ],
      courseIndex:0,
      isHoverCourse:false,
      teachers:[
                    {name:"汪兴毅",years:"22年教学经验",courseName:"《工程法规》",jianjie:"网校独家签约老师，高校副教授、研究生导师",
          tese:"讲课诙谐生动，善于用生动形象的案例解释难以理解的考点。",pinjia:"感谢汪老师，跟着您的脚步按部就班听了两遍，只看了课件，没看书，过了。"},
                    {name:"王竹梅",years:"12年教学经验",courseName:"《建设工程法规及相关知识》",jianjie:"中国人民大学硕士、全国高级培训师",
          tese:"思路清晰、逻辑性强、讲解深刻透彻，擅于归纳、总结、辨析，独创梳理法。",pinjia:"王老师思路清晰，要点都做了归纳总结，知识点讲的也比较通透，对我这种小白来说学习觉得有信心。"},
                    {name:"赵景满",years:"7年教学经验",courseName:"《矿业工程》",jianjie:"高校副教授",
          tese:"讲课条理清晰，善于理论结合实际案例讲解。",pinjia:"讲课系统全面，条例清晰，考点命中率高。"},
                    {name:"凌平平",years:"10年教学经验",courseName:"《市政工程》",jianjie:"网校独家签约老师，高校副教授，一级建造师",
          tese:"讲课逻辑性强，善于梳理知识点脉络，将考点按性质分类讲解。",pinjia:"带着传业授道解惑的微笑，讲的内容引人入胜，音调温和入耳、整体形象让人忽视课堂的严肃而更有活力。"},
                    {name:"胡云",years:"8年教学经验",courseName:"《机电工程》",jianjie:"网校独家签约老师，一级建造师、高级工程师",
          tese:"讲课偏重实践操作，图文并茂，善于归纳总结。",pinjia:"非常详细认真细致讲课，对于我这种初学者来说感觉还是比较容易吸收，还是得通过不断的练习才行，谢谢老师。"},
                    {name:"韩铎",years:"7年教学经验",courseName:"《机电工程》",jianjie:"硕士，一级建造师，主编多部机电类教辅",
          tese:"善于把工程经验和图表融入教学，清晰易懂。",pinjia:"能够真正从学员角度思考问题，帮助通过考试。"},
                    {name:"杨志梁",years:"25年教学经验",courseName:"《建筑工程》",jianjie:"高校副教授，研究生导师",
          tese:"讲课通俗易懂，紧扣大纲考点，擅长预测考点。",pinjia:"讲课条理有序，清楚不零乱！对重点、难点都能一一讲得清楚！我喜欢听。"},
                    {name:"李俊宏",years:"10年教学经验",courseName:"《水利水电》",jianjie:"网校独家签约老师，高校副教授、研究生导师",
          tese:"讲课应试性强，善于讲解案例题将所有知识点融会贯通。",pinjia:"果断选择了李老师的课，非常受益。"},
                    {name:"龙炎飞",years:"12年教学经验",courseName:"《施工管理》",jianjie:"同济大学硕士研究生，一级建造师，二级建造师，业内建造师辅导大咖",
          tese:"授课生动形象，考点讲解深入透彻，重点突出，考生理解和记忆快速，稳步提分。",pinjia:""},
                    {name:"赵春晓",years:"11年教学经验",courseName:"《施工管理》",jianjie:"网校独家签约老师，中国矿业大学博士、一级建造师",
          tese:"讲课幽默风趣，善于将社会现象引入课程之中，帮助考生快速高效记忆。",pinjia:"我白板一枚都能听懂，看着赵老师又赏心悦目，最后还鼓舞人心，很好。"},
                    {name:"郭炜",years:"15年教学经验",courseName:"《市政工程》",jianjie:"网校独家签约老师，博士，985名校副教授，一级建造师，造价工程师",
          tese:"讲课热情饱满全面细致，善于提炼针对性辅导。",pinjia:"郭炜老师讲解清楚，思路清晰，听他的课明年考过有了很大信心，谢谢郭老师。"},
          
      ],
      teacherIndex:10,
      tixiIndex:0,
    };
  },
  created(){
    this.href=encodeURIComponent(window.location.href);
    var config=JSON.parse(sessionStorage.getItem(window.location.host+"puconfig"));
    if(config.KefuTelList.length>0){
      this.kefu=config.KefuTelList[0].KefuNumber;
    }
    this.unionId=config.UnionId
    this.logo=config.UnionLogo;
    this.allLoginPlayFlag=config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if(token!=undefined){
        this.isLogin=true;
        getMemberPicpath({},(res)=>{
            this.logoSrc=res;
        });
    }else{
        var interval= setInterval(() => {
        token = localStorage.getItem("usertoken");
        if(token!=undefined){
          this.isLogin=true;
          getMemberPicpath({},(res)=>{
            this.logoSrc=res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods:{
      loginout(){
          this.isLogin=false;
          this.logoSrc="";
          localStorage.removeItem("usertoken");
      },
      scroll(num){
        document.documentElement.scrollTop=num;
      },
     changeCourseIndex(i){
       this.courseIndex=i;
     },
    changeIsHoverCourse(flag){
      this.isHoverCourse=flag;
    },
    changehoverindex(i){
      this.hoverindex=i;
    },
    changeTeacherIndex(i){
      this.teacherIndex=i;
    },
    changeTixiIndex(i){
        this.tixiIndex=i;
    }
  },
}
</script>